module.exports = __webpack_public_path__ + "img/icon-copy.1b03856f.svg";